import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { ProgressBar } from '@uhg-abyss/web/ui/ProgressBar';
import { Skeleton } from '@uhg-abyss/web/ui/Skeleton';
import { isEmpty } from 'lodash';
import React from 'react';

/**
 * Details
 *
 * @TODO - Needs description.
 *
 * @param handleExport
 * @param isLoading
 * @param show
 * @param sourceDetail
 * @returns {React.JSX.Element|null}
 * @constructor
 */
export function Details({ handleExport, isLoading, show, sourceDetail }) {
  if (isLoading) {
    return <Skeleton height={350} />;
  }

  if (!show) {
    return null;
  }

  return (
    <ErrorHandler location="src/pages/private/Dashboards/SourceReportsDashboard/components/Details/Details.jsx">
      <Widget description={sourceDetail.name} title={sourceDetail.source}>
        <Grid>
          <Grid.Col span={{ xs: 6 }}>
            <Flex css={{ gap: '12px' }}>
              {!isEmpty(sourceDetail.lob) && (
                <Badge outline variant="neutral">
                  {sourceDetail.lob}
                </Badge>
              )}
              {!isEmpty(sourceDetail.attribute) && (
                <Badge outline variant="neutral">
                  {sourceDetail.attribute}
                </Badge>
              )}
            </Flex>
          </Grid.Col>
          <Grid.Col span={{ xs: 12 }}>
            {sourceDetail.remediationActionTaken.map((action, index) => {
              return (
                <ProgressBar
                  fillColor="$primary1"
                  height={33}
                  key={index}
                  label={action.action}
                  maxLabel={Math.round(action.count / (action.percentage / 100))}
                  minLabel="0"
                  percentage={Math.round(action.percentage)}
                  progressLabel={action.count}
                  showProgress
                  subText={`${Math.round(action.percentage)}%`}
                />
              );
            })}
          </Grid.Col>
          <Grid.Col css={{ alignContent: 'flex-end' }} span={{ xs: 12 }}>
            <Flex direction="row-reverse">
              <Button before={<IconSymbol icon="upload_2" />} onClick={handleExport} variant="outline">
                Export to Sharepoint
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </Widget>
    </ErrorHandler>
  );
}
